import React from 'react';
import { usePermission } from '../context/PermissionContext';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';

/* ── Access Denied Page ── */
var AccessDeniedPage = function (props) {
  var navigate = useNavigate();
  var module = props.module || '';
  var action = props.action || 'view';
  var _pc = usePermission();
  var role = _pc.role;
  var roleName = (role && typeof role === 'object' && role.name) ? role.name : (typeof role === 'string' ? role : 'your current role');

  return React.createElement(AdminLayout, null,
    React.createElement('div', {
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '65vh',
        padding: '40px 24px',
        textAlign: 'center',
        fontFamily: "'DM Sans', sans-serif",
      }
    },
      React.createElement('div', {
        style: {
          fontSize: '72px',
          fontWeight: 800,
          background: 'linear-gradient(135deg, #EF4444 0%, #F87171 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          lineHeight: 1,
          marginBottom: 12,
        }
      }, '403'),
      React.createElement('div', {
        style: {
          width: 72,
          height: 72,
          borderRadius: '50%',
          background: 'rgba(239, 68, 68, 0.12)',
          border: '1.5px solid rgba(239, 68, 68, 0.3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 20,
        }
      },
        React.createElement('svg', {
          viewBox: '0 0 24 24', fill: 'none', stroke: '#EF4444',
          strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round',
          width: 32, height: 32,
        },
          React.createElement('rect', { x: 3, y: 11, width: 18, height: 11, rx: 2, ry: 2 }),
          React.createElement('path', { d: 'M7 11V7a5 5 0 0 1 10 0v4' })
        )
      ),
      React.createElement('h2', {
        style: {
          fontSize: '1.6rem', fontWeight: 700, color: '#FFFFFF',
          margin: '0 0 8px', letterSpacing: '-0.02em',
        }
      }, '403 - Access Denied'),
      React.createElement('p', {
        style: {
          color: '#C4B5FD', fontSize: '0.95rem', maxWidth: 420,
          lineHeight: 1.6, margin: '0 0 8px',
        }
      },
        module
          ? 'You do not have permission to ' + action + ' the "' + module + '" module.'
          : 'You do not have permission to access this page.'
      ),
      React.createElement('p', {
        style: { color: '#94A3B8', fontSize: '0.85rem', margin: '0 0 28px' }
      }, 'Current Role: ', React.createElement('strong', { style: { color: '#F0C24B' } }, roleName)),
      React.createElement('button', {
        onClick: function () { navigate('/admin/dashboard'); },
        style: {
          padding: '12px 28px',
          borderRadius: 12,
          border: 'none',
          background: 'linear-gradient(135deg, #6D28D9, #A855F7)',
          color: '#FFFFFF',
          fontSize: '0.9rem',
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 8px 24px rgba(109, 40, 217, 0.35)',
        }
      }, 'Back to Dashboard')
    )
  );
};

/* ── PermissionGate ── */
// Usage: <PermissionGate module="products" action="view">
//          <ProductsPage />
//        </PermissionGate>
var PermissionGate = function (props) {
  var module = props.module;
  var action = props.action || 'view';
  var children = props.children;

  var _pc = usePermission();
  var hasPermission = _pc.hasPermission;
  var permissionsLoaded = _pc.permissionsLoaded;
  var isSuperAdmin = _pc.isSuperAdmin;

  // Super Admin always bypasses module permission checks instantly
  if (isSuperAdmin) {
    return children;
  }

  // While permissions are loading for non-super admins, render loading state
  if (!permissionsLoaded) {
    return React.createElement('div', {
      style: { padding: 40, textAlign: 'center', color: '#64748b', fontSize: '0.9rem' }
    }, 'Checking permissions…');
  }

  if (!hasPermission(module, action)) {
    return React.createElement(AccessDeniedPage, { module: module, action: action });
  }

  return children;
};

export default PermissionGate;
